import { contentType } from '~/types/content.type'

export const IMAGE_URL = 'https://globalstatic.xangle.io/explorer-plus/aptos'

export const IMAGE = {
  bannerLogo: `${IMAGE_URL}/banner-logo.png`,
  background: `${IMAGE_URL}/main-background.png`,
  header: `${IMAGE_URL}/home-header.png`,
  logo: `${IMAGE_URL}/logo.png`,
  thumbnail: {
    [contentType.RESEARCH]: `${IMAGE_URL}/thumbnail/research.png`,
    [contentType.NOTICE]: `${IMAGE_URL}/thumbnail/notice.png`,
    [contentType.BLOG]: `${IMAGE_URL}/thumbnail/blog.png`,
    [contentType.EVENT]: `${IMAGE_URL}/thumbnail/event.png`,
    ecosystem: `${IMAGE_URL}/thumbnail/ecosystem.png`,
    person: `${IMAGE_URL}/thumbnail/person.png`,
  }
}